__turbopack_context__.v({
  "buttonNext": "BlockProductPairingsSlides-module-scss-module__iIPFNG__buttonNext",
  "buttonPrev": "BlockProductPairingsSlides-module-scss-module__iIPFNG__buttonPrev",
  "fade-in": "BlockProductPairingsSlides-module-scss-module__iIPFNG__fade-in",
  "fade-out": "BlockProductPairingsSlides-module-scss-module__iIPFNG__fade-out",
  "flushBottom": "BlockProductPairingsSlides-module-scss-module__iIPFNG__flushBottom",
  "flushTop": "BlockProductPairingsSlides-module-scss-module__iIPFNG__flushTop",
  "inner": "BlockProductPairingsSlides-module-scss-module__iIPFNG__inner",
  "lastBlock": "BlockProductPairingsSlides-module-scss-module__iIPFNG__lastBlock",
  "paginationButton": "BlockProductPairingsSlides-module-scss-module__iIPFNG__paginationButton",
  "paginationControls": "BlockProductPairingsSlides-module-scss-module__iIPFNG__paginationControls",
  "paginationControls--show": "BlockProductPairingsSlides-module-scss-module__iIPFNG__paginationControls--show",
  "paginationControlsInner": "BlockProductPairingsSlides-module-scss-module__iIPFNG__paginationControlsInner",
  "paginationCount": "BlockProductPairingsSlides-module-scss-module__iIPFNG__paginationCount",
  "root": "BlockProductPairingsSlides-module-scss-module__iIPFNG__root",
  "slide": "BlockProductPairingsSlides-module-scss-module__iIPFNG__slide",
  "slide-active": "BlockProductPairingsSlides-module-scss-module__iIPFNG__slide-active",
  "slide-prev": "BlockProductPairingsSlides-module-scss-module__iIPFNG__slide-prev",
  "slides": "BlockProductPairingsSlides-module-scss-module__iIPFNG__slides",
  "theme--makers-reserve": "BlockProductPairingsSlides-module-scss-module__iIPFNG__theme--makers-reserve",
});
